<wr-base-dialog
  [header]="title"
  [showSubmitButton]="false"
  [nbSpinner]="loading()"
>
  <wr-list-view
    [items]="filteredBuildingEquipments()"
    [(searchText)]="searchText"
    (searchTextChange)="searchTextChange($event)"
  >
    <ng-template wrListItem let-item>
      <div class="equipment-row">
        <div class="equipment-left">
          <div class="user-wrapper">
            <nb-user
              [name]="item.buildingEquipmentName"
              [picture]="getIcon(item)"
              size="large">
            </nb-user>
          </div>
          <div class="building-info">
            {{ item.buildingName }}
          </div>
        </div>
        <button nbButton status="info" size="large" [nbTooltip]="'Gebäudeausstattung'"
                (click)="navigateToBuildingEquipments($event, item.equipmentId, item.buildingId)" >
          <nb-icon pack="fas" icon="box"></nb-icon>
        </button>
      </div>
    </ng-template>
  </wr-list-view>
</wr-base-dialog>
